import { Box, Typography, useTheme, useMediaQuery, createTheme } from "@mui/material";
// import Form from "./form1";
import Form from './NewForm';

const LoginPage = () => {
    const theme = useTheme();
    // const isNonMobileScreens = useMediaQuery("(min-width: 1000px)");
    return (
        <html>
            <head>

            </head>
            <Form/>
            {/* <Form /> */}
        </html>
    );
};

export default LoginPage;







